module.exports = __webpack_public_path__ + "img/huoke_icon8.e9b6acbb.png";